import React from 'react';
export function Section({
  children,
  className = '',
  id,
  variant = 'default'
}: {
  children: React.ReactNode;
  className?: string;
  id?: string;
  variant?: 'default' | 'alt';
}) {
  const bgClass = variant === 'alt' ? 'bg-brand-bgAlt' : '';
  return <section id={id} className={bgClass} data-id="element-306">
      <div className={`py-8 md:py-12 px-4 max-w-6xl mx-auto ${className}`} data-id="element-307">
        {children}
      </div>
    </section>;
}